import { Trans } from '@lingui/macro';
import React, { FC, useState, useEffect, useContext } from 'react'
import { contains, indexOf, isEmpty } from 'underscore';
import { Context } from '../../..';
import UserService from '../../../services/UserService';

interface ItemProps {
    item: {
        id: number,
        specialization: string;
    },
    selected: [],
    setSelected: (value: any[]) => void
};

const Item = (props: ItemProps) => {
    const { item, selected, setSelected } = props;
    const { id, specialization } = item;
    const checked = contains(selected, id);

    const onChange = () => {
        const sel: any[] = selected.slice();
        if (contains(sel, id)) {
            sel.splice(indexOf(sel, id), 1)
        } else {
            sel.push(id);
        };
        setSelected(sel);
    };

    return (
        <div className="form-check">
            <input className="form-check-input" type="checkbox" checked={checked} id={`item${id}`} name="item" onChange={() => onChange()} />
            <label className="form-check-label" htmlFor={`item${id}`}>{specialization}</label>
        </div>
    );
};

export const SpecializationModal: FC = () => {
    const { store } = useContext(Context);
    const [query, setQuery] = useState('');
    const [newSpec, setNewSpec] = useState('');
    const [specializations, setSpecializations] = useState<[]>([]);
    const [popov, setPopov] = useState<boolean>(false);
    const [specTitle, setSpecTitle] = useState<string[]>([]);
    const [selected, setSelected] = useState<any>(store.specInfo?.specializations || []);
    const [specPopover, setSpecPopover] = useState<boolean>(false);

    const getSpecializations = async () => {
        const res = await UserService.getSpecializations(query);
        setSpecializations(res.data.results);
    };

    useEffect(() => {
        getSpecializations();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [query]);

    useEffect(() => {
        if (!isEmpty(specializations)) {
            setSpecTitle([]);
            // eslint-disable-next-line array-callback-return
            specializations.map(item => {
                // eslint-disable-next-line array-callback-return
                selected.map((sid: any) => {
                    if (item['id'] === sid) {
                        setSpecTitle(specTitle => [...specTitle, item['specialization']]);
                    }
                });
            });
        };
    }, [selected, specializations]);

    const getItems = () => {
        if (!isEmpty(specializations)) {
            return specializations.map(item => <Item key={item['id']} {...{ item, selected, setSelected }} />);
        } else {
            return <span><Trans>Nothing found</Trans></span>
        }
    };

    const openPopov = (e: React.ChangeEvent<any>) => {
        setPopov(true);
        e.target.value = ''
    };

    const closePopov = () => {
        setPopov(false);
        store.setSpecInfo({ ...store.specInfo, "specializations": selected })
    };

    const onChange = (e: any) => {
        if (e.target.value.length > 1) {
            setQuery(e.target.value);
        }
    };

    const addSpecialization = async () => {
        try {
            await UserService.createSpecialization({ 'query': newSpec });
            setQuery('');
            getSpecializations();
        } catch (e) {
            console.log(e);
        };
    }

    return (
        <div className="form-group" style={{position: "relative"}}>
            <div className="input-group">
                <div className="input-group-control w-100">
                    {popov ?
                        <input type="text" className="form-control"
                            defaultValue=''
                            placeholder={store.lang === 'ba' ? 'Табыр өсөн тексты индерә башлағыҙ' : store.lang === 'ru' ? 'Начните вводить текст, чтобы найти' : 'Start typing to find'}
                            autoComplete="off"
                            onChange={(e: React.ChangeEvent<any>) => onChange(e)} />
                        :
                        <input type="text" className="form-control"
                            placeholder={store.lang === 'ba' ? 'Һөнәр һайлағыҙ' : store.lang === 'ru' ? 'Выберите специальность' : 'Choose a specialty'}
                            value={specTitle.join(', ')}
                            title={specTitle.join(', ')}
                            readOnly
                            autoComplete="off"
                            onClick={(e: React.ChangeEvent<any>) => openPopov(e)}
                            onChange={() => { }} />
                    }
                </div>
            </div>
            {popov ?
                <div className="form-group popov">
                    <div className="popov__title d-flex justify-content-between">
                        <div>
                            <button type='button' className='btn btn-light' value='' onClick={() => setSpecPopover(true)}><i className='icon add' /><Trans>Add a new specialization to the list</Trans></button>
                        </div>
                        <div>
                            <input type='button' className='btn text-primary' value={store.lang === 'ba' ? 'Ябырға' : store.lang === 'ru' ? 'Закрыть' : 'Close'} onClick={() => { closePopov(); setSpecPopover(false); setQuery('') }} />
                        </div>
                    </div>
                    <div className="form-group">
                        {!specPopover ?
                            getItems()
                            :
                            <div className="form-control">
                                <input type="text" className="form-control"
                                    placeholder={store.lang === 'ba' ? 'Һөнәрегеҙҙең исемен индерегеҙ' : store.lang === 'ru' ? 'Введите название вашей специальности' : 'Enter the name of your specialty'}
                                    autoComplete="off"
                                    onChange={(e: React.ChangeEvent<any>) => setNewSpec(e.target.value)} />
                                <div className='text-center'>
                                    <input type='button'
                                        onClick={() => { addSpecialization(); setSpecPopover(false) }}
                                        value={store.lang === 'ba' ? 'Өҫтәргә' : store.lang === 'ru' ? 'Добавить' : 'Add'}
                                        className="btn btn-gray m-1" />
                                    <input type='button'
                                        onClick={() => setSpecPopover(false)}
                                        value={store.lang === 'ba' ? 'Кире ҡайтарыу' : store.lang === 'ru' ? 'Отмена' : 'Cancel'}
                                        className="btn btn-gray m-1" />
                                </div>
                            </div>
                        }
                    </div>
                </div>
                : null}
        </div>
    );
};